import React from 'react';
import axios from 'axios';
import NoSSR from 'react-no-ssr';

const internal_ads_url = 'https://us-central1-actionvfx-cms-middleware.cloudfunctions.net';

class InternalAd extends React.Component {
  constructor(props) {
    super(props);
  }

  getDesiredHeight() {
    return this.props.height || $(this.props.selector_for_height).height();
  }

  getLinkUrl() {
    const link = encodeURIComponent(this.props.link_url);
    const user_id = window.avfx_user_id;
    return `${internal_ads_url}/follow?to=${link}&user_id=${user_id}&placement=${this.props.placement}&ad=${this.props.slug}`;
  }

  render() {
    const { title, subtitle, background_image, cta_button_text, link_url } = this.props;

    const adBgStyle = background_image != null ? 'rgba(0,0,0,0.4)' : 'transparent';

    return (
      <div
        className={'internal-ad-container'}
        style={{
          backgroundColor: this.props.background_color,
          backgroundImage: `url(${background_image})`,
          height: this.getDesiredHeight() + 'px'
        }}
      >
        <div className="internal-ad" style={{ backgroundColor: adBgStyle }}>
          <div className="internal-ad-content">
            <h3 className="internal-ad-title">{title}</h3>
            <h5 className="internal-ad-subtitle pb-8 pt-4 leading-snug">{subtitle}</h5>
            <a href={this.getLinkUrl()} className="button secondary internal-ad-cta">
              {cta_button_text}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

class InternalAdsContainerComponent extends React.Component {
  getAds(placement, callback) {
    if (
      (this.state.items !== undefined && this.state.items.length > 0) ||
      this.state.loading == true
    ) {
      return false;
    }
    if (internal_ads_url === undefined || internal_ads_url.length === 0) {
      return false;
    }

    // We only want to do this once per page load, regardless of Next hydration.
    if (window.internal_ads !== undefined) {
      return false;
    }
    let that = this;
    this.setState({ loading: true });
    const url = internal_ads_url + '/getAds';

    axios
      .get(url, {
        params: {
          placement: placement,
          user_id: window.avfx_user_id
        }
      })
      .then(function (response) {
        window.internal_ads = response.data.stories;
        callback();
        that.setState({ loading: false });
      });
  }

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      loading: false,
      items: [],
      key: Date.now()
    };

    this.adsLoaded = this.adsLoaded.bind(this);
  }

  adsLoaded() {
    let items = window.internal_ads;
    this.setItems(items);
    const key = this.state.key;
    // setTimeout(() => {
    //   if (typeof document !== 'undefined') {
    //     $(`#ads-${key}`).not('.slick-initialized').slick({
    //       infinite: true,
    //       dots: true,
    //       autoplay: true,
    //       autoplaySpeed: 6000,
    //       arrows: false
    //     });
    //   }
    // }, 500)
  }

  componentDidMount() {
    this.getAds(this.props.placement, this.adsLoaded);

    if (
      (this.state.items == undefined || this.state.items.length == 0) &&
      window.internal_ads !== undefined &&
      window.internal_ads.length > 0
    ) {
      this.adsLoaded();
    }
  }

  applyFilterRules(items) {
    // There's probably a nicer way to do this that I'm not seeing right now.
    return items.filter((item) => {
      if (!item.content.rules) return true;
      if (item.content.rules.includes('subscribed') && !this.props.subscribed) return false;
      if (item.content.rules.includes('not_subscribed') && this.props.subscribed) return false;
      if (item.content.rules.includes('logged_in') && !this.props.logged_in) return false;
      if (item.content.rules.includes('not_logged_in') && this.props.logged_in) return false;
      if (item.content.rules.includes('has_purchased') && !this.props.has_purchased) return false;
      if (item.content.rules.includes('has_not_purchased') && this.props.has_purchased)
        return false;
      if (item.content.rules.includes('individual') && !this.props.individual) return false;
      if (item.content.rules.includes('studio') && !this.props.studio) return false;
      return true;
    });
  }

  setItems(items) {
    if (items === undefined) {
      return [];
    }
    // Apply filter rules, i.e. don't show if subscribed and etc
    items = this.applyFilterRules(items);

    // Let's always randomize
    items = this.shuffleArray(items);

    // If we have custom positions set, let's enforce them
    items.sort(function (a, b) {
      let keyA = a.content.priority;
      let keyB = b.content.priority;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    this.setState({ items: items });
  }

  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  renderAds() {
    return (
      this.state.items !== undefined &&
      this.state.items.map((ad) => (
        <InternalAd
          key={ad.slug}
          slug={ad.slug}
          placement={this.props.placement}
          title={ad.content.title}
          subtitle={ad.content.subtitle}
          link_url={ad.content.link_url.url}
          cta_button_text={ad.content.cta_button_text}
          background_image={ad.content.background_image.filename}
          background_color={ad.content.background_color}
          selector_for_height={this.props.selector_for_height}
          height={this.props.height}
        ></InternalAd>
      ))
    );
  }

  render() {
    const { items } = this.state;
    return (
      <div>
        {items !== null && items.length > 0 && (
          <div
            className={`slider-container ads-container placement-${this.props.placement} ${this.props.containerClasses}`}
            id={`ads-${this.state.key}`}
          >
            {this.renderAds()}
          </div>
        )}
      </div>
    );
  }
}

export const InternalAdsContainer = (props) => (
  <NoSSR>
    <InternalAdsContainerComponent {...props} />
  </NoSSR>
);
